import React, { CSSProperties, ReactNode } from 'react';

import CustomTooltip from '../CustomTooltip/CustomTooltip';
import IconContainer from './IconContainer';

import './style.scss';

interface FtuxComponentProps {
  icon?: ReactNode;
  title?: string;
  text?: string;
  buttonText?: string;
  onClick?: () => void;
  buttonIcon?: ReactNode;
  buttonRightIcon?: ReactNode;
  height?: string | number;
  width?: string | number;
  buttonDisableStatus?: boolean;
  buttonTooltipText?: string;
  iconBgColor?: string;
  buttonStyles?: CSSProperties;
  titleStyle?: CSSProperties;
  textStyle?: CSSProperties;
}

export default function FtuxComponent({
  icon,
  title,
  text,
  buttonText,
  onClick,
  buttonIcon,
  buttonRightIcon,
  height,
  width = 320,
  buttonDisableStatus = false,
  buttonTooltipText = '',
  iconBgColor,
  buttonStyles,
  titleStyle,
  textStyle,
}: FtuxComponentProps) {
  return (
    <div className="ftux-container" style={{ height: height || 'calc(100vh - 150px)' }}>
      <div className="inner-container" style={{ maxWidth: width }}>
        {icon && <IconContainer bgColor={iconBgColor} icon={icon} />}
        {title && <h2 style={{ ...titleStyle }}>{title}</h2>}
        {text && <div className="text-container" style={{ ...textStyle }} dangerouslySetInnerHTML={{ __html: text }} />}
        {buttonText && (
          <CustomTooltip title={buttonTooltipText}>
            <button onClick={onClick} disabled={buttonDisableStatus} style={buttonStyles}>
              {buttonIcon && buttonIcon} {buttonText} {buttonRightIcon && buttonRightIcon}
            </button>
          </CustomTooltip>
        )}
      </div>
    </div>
  );
}
